import $ from 'jquery';

class MiniCart {
	constructor() {
		this.body = $( 'body' );
		this.wrapper = $( '[data-mini-cart-wrapper]' );
		this.miniCart = '';

		$( document ).ready( this.events.bind( this ) );
	}

	events() {
		this.wrapper.on( 'click', '[data-mini-cart-link]', this.miniCartClicked.bind( this ) );
		document.addEventListener( 'click', this.outsideClickListener.bind( this ) );
	}

	miniCartClicked( e ) {
		this.miniCart = this.wrapper.find( '.widget_shopping_cart' );

		e.preventDefault();

		if ( this.miniCart.is( ':visible' ) ) {
			this.hideCart( this.miniCart );
			return;
		}

		this.showCart( this.miniCart );
	}

	outsideClickListener( e ) {
		this.miniCart = this.wrapper.find( '.widget_shopping_cart' );

		if ( ! $( e.target ).closest( '[data-mini-cart-wrapper]' ).length ) {
			if ( this.miniCart.is( ':visible' ) ) {
				this.hideCart( this.miniCart );
			}
		}
	}

	removeClickListener() {
		document.removeEventListener( 'click', this.outsideClickListener );
	}

	showCart( miniCart ) {
		$( window ).scrollTop( 0 );
		miniCart.fadeIn( 200 );
		this.wrapper.addClass( 'cart-open' );
		this.body.addClass( 'no-scroll' );
	}

	hideCart( miniCart ) {
		miniCart.fadeOut( 150 );
		this.wrapper.removeClass( 'cart-open' );
		this.body.removeClass( 'no-scroll' );
		this.removeClickListener();
	}
}

export default MiniCart;
